// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentPdfFileModel {
    static getAttributeTypeMap() {
        return DocumentPdfFileModel.attributeTypeMap;
    }
}
DocumentPdfFileModel.discriminator = undefined;
DocumentPdfFileModel.additionalProperties = false;
DocumentPdfFileModel.attributeTypeMap = [
    {
        "name": "templateName",
        "baseName": "templateName",
        "type": "string"
    },
    {
        "name": "author",
        "baseName": "author",
        "type": "string"
    },
    {
        "name": "title",
        "baseName": "title",
        "type": "string"
    },
    {
        "name": "keywords",
        "baseName": "keywords",
        "type": "string"
    },
    {
        "name": "headerMarginLeft",
        "baseName": "headerMarginLeft",
        "type": "string"
    },
    {
        "name": "headerMarginRight",
        "baseName": "headerMarginRight",
        "type": "string"
    },
    {
        "name": "headerStyle",
        "baseName": "headerStyle",
        "type": "string"
    },
    {
        "name": "tableStyle",
        "baseName": "tableStyle",
        "type": "string"
    },
    {
        "name": "overWriteExisting",
        "baseName": "overWriteExisting",
        "type": "boolean"
    },
    {
        "name": "tableHeaderText",
        "baseName": "tableHeaderText",
        "type": "string"
    },
    {
        "name": "documentData",
        "baseName": "documentData",
        "type": "{ [key: string]: string; }"
    },
    {
        "name": "headerData",
        "baseName": "headerData",
        "type": "{ [key: string]: string; }"
    },
    {
        "name": "documentStyles",
        "baseName": "documentStyles",
        "type": "Array<DocumentPdfFileStyleModel>"
    },
];
//# sourceMappingURL=documentPdfFileModel.js.map